/* global pagination http searchFilter formHelper */
/*eslint-disable no-unused-vars*/
const filterPagination = {
	vars: {
		currentPage: 1
	},

	fxFilterPaginationItemHelper(selector, element, endpoint) {
		document.addEventListener('click', e => {
			if (e.target && e.target.classList.contains('pagination__item') && e.target.closest('.js-search').querySelector(selector)) {
				const paginationList = e.target.parentElement,
					page = Number(e.target.querySelector('button').textContent),
					searchContainer = element.closest('.js-search') ? element.closest('.js-search') : element.closest('.modal').previousElementSibling,
					form = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-filter-modal') ? searchContainer.nextElementSibling.querySelector('.js-filter-modal') : element,
					input = searchContainer.querySelector('.js-autocomplete'),
					term = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-search-term') ? searchContainer.nextElementSibling.querySelector('.js-search-term') : '',
					range = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range') : '',
					rangeStart = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-start') : '',
					rangeEnd = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-end') : ''

				searchContainer.nextElementSibling && term ? term.value = input.value : ''
				searchContainer.nextElementSibling && range && range.noUiSlider ? rangeStart.value = range.noUiSlider.get()[0] : ''
				searchContainer.nextElementSibling && range && range.noUiSlider ? rangeEnd.value = range.noUiSlider.get()[1] : ''

				const callback = response => {
					searchFilter.fxFilterCallback(response, element, page)
					e.target.closest('.pagination__list').querySelectorAll('.pagination__item').forEach(el => el.classList.remove('is-active'))
					e.target.classList.add('is-active')
				}

				http.fxPost(`${endpoint.substring(0, endpoint.lastIndexOf('/') + 1)}${page}`, formHelper.fxFormToJson(form), callback).then(response => {
					this.vars.currentPage = response.data.pagination.filter(el => {
						if (el.currentPage) return el
					})[0].page
					setTimeout(() => pagination.fxPaginationItemHelper(response, paginationList, this.vars.currentPage), 0)
					pagination.fxPaginationHelper(response, paginationList)
				})
			}
		})
	},

	fxFilterNavigationHelper(selector, endpoint, filter) {
		const searchContainer = filter.closest('.js-search'),
			input = searchContainer.querySelector('.js-autocomplete'),
			term = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-search-term') ? searchContainer.nextElementSibling.querySelector('.js-search-term') : '',
			range = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range') : '',
			rangeStart = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-start') : '',
			rangeEnd = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-end') : ''

		pagination.el.paginationButtonPrev.forEach(el => el.addEventListener('click', e => {
			if (e.target.closest('.js-search').querySelector(selector)) {
				this.vars.currentPage--

				searchContainer.nextElementSibling && term ? term.value = input.value : ''
				searchContainer.nextElementSibling && range && range.noUiSlider ? rangeStart.value = range.noUiSlider.get()[0] : ''
				searchContainer.nextElementSibling && range && range.noUiSlider ? rangeEnd.value = range.noUiSlider.get()[1] : ''

				pagination.fxNavigationHelper(endpoint, '', e.target.nextElementSibling, this.vars.currentPage, filter)
			}
		}))

		pagination.el.paginationButtonNext.forEach(el => el.addEventListener('click', e => {
			if (e.target.closest('.js-search').querySelector(selector)) {
				this.vars.currentPage++

				searchContainer.nextElementSibling && term ? term.value = input.value : ''
				searchContainer.nextElementSibling && range && range.noUiSlider ? rangeStart.value = range.noUiSlider.get()[0] : ''
				searchContainer.nextElementSibling && range && range.noUiSlider ? rangeEnd.value = range.noUiSlider.get()[1] : ''

				pagination.fxNavigationHelper(endpoint, '', e.target.previousElementSibling, this.vars.currentPage, filter)
			}
		}))
	}
}